import React from "react";
import { Outlet } from "react-router-dom";

import useGoogleAnalytics from "../../hooks/useGoogleAnalytics";
import useHubSpot from "../../hooks/useHubspot";

function AppInitializer() {
  useGoogleAnalytics();
  useHubSpot();
  return <Outlet />;
}

export default AppInitializer;
